import { teardown } from '../../reactivity/effects.js';
import { define_property, is_array } from '../../../shared/utils.js';
import { hydrating } from '../hydration.js';
import { queue_micro_task } from '../task.js';
import { FILENAME } from '../../../../constants.js';
import * as w from '../../warnings.js';
import {
	active_effect,
	active_reaction,
	set_active_effect,
	set_active_reaction
} from '../../runtime.js';
import { without_reactive_context } from './bindings/shared.js';

/*                      */
export const all_registered_events = new Set();

/*                                               */
export const root_event_handles = new Set();

/**
 *
 *
 *
 */
export function replay_events(dom) {
	if (!hydrating) return;

	dom.removeAttribute('onload');
	dom.removeAttribute('onerror');
	/*               */
	const event = dom.__e;
	if (event !== undefined) {
		/*               */
		dom.__e = undefined;
		queueMicrotask(() => {
			if (dom.isConnected) {
				dom.dispatchEvent(event);
			}
		});
	}
}

/**
 *
 *
 *
 *
 */
export function create_event(event_name, dom, handler, options = {}) {
	/**
 *
 */
	function target_handler(/*                */ event) {
		if (!options.capture) {
			/*                                                                                               */
			handle_event_propagation.call(dom, event);
		}
		if (!event.cancelBubble) {
			return without_reactive_context(() => {
				return handler?.call(this, event);
			});
		}
	}

	/*                                                                                                   */
	/*                                                                                                    */
	/*                                                                                                      */
	/*                                                           */
	if (
		event_name.startsWith('pointer') ||
		event_name.startsWith('touch') ||
		event_name === 'wheel'
	) {
		queue_micro_task(() => {
			dom.addEventListener(event_name, target_handler, options);
		});
	} else {
		dom.addEventListener(event_name, target_handler, options);
	}

	return target_handler;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function on(element, type, handler, options = {}) {
	var target_handler = create_event(type, element, handler, options);

	return () => {
		element.removeEventListener(type, target_handler, options);
	};
}

/**
 *
 *
 *
 *
 *
 *
 */
export function event(event_name, dom, handler, capture, passive) {
	var options = { capture, passive };
	var target_handler = create_event(event_name, dom, handler, options);

	if (
		dom === document.body ||
		/*         */
		dom === window ||
		/*         */
		dom === document ||
		/*                                                                                                                */
		dom instanceof HTMLMediaElement
	) {
		teardown(() => {
			dom.removeEventListener(event_name, target_handler, options);
		});
	}
}

/**
 *
 *
 */
export function delegate(events) {
	for (var i = 0; i < events.length; i++) {
		all_registered_events.add(events[i]);
	}

	for (var fn of root_event_handles) {
		fn(events);
	}
}

/**
 *
 *
 *
 */
export function handle_event_propagation(event) {
	var handler_element = this;
	var owner_document = /*               */ (handler_element).ownerDocument;
	var event_name = event.type;
	var path = event.composedPath?.() || [];
	var current_target = /*                         */ (path[0] || event.target);

	/*                                                                    */
	/*                                                           */
	/*                                                             */
	/*                                                                         */
	var path_idx = 0;

	/*                              */
	var handled_at = event.__root;

	if (handled_at) {
		var at_idx = path.indexOf(handled_at);
		if (
			at_idx !== -1 &&
			(handler_element === document || handler_element === /*              */ (window))
		) {
			/*                                                                                             */
			/*                                                                                */
			/*                                                                     */
			/*               */
			event.__root = handler_element;
			return;
		}

		/*                                                              */
		/*                                                                         */
		/*                                                                              */
		/*                                                                                */
		/*                                                                              */
		var handler_idx = path.indexOf(handler_element);
		if (handler_idx === -1) {
			/*                                                                                                                        */
			/*                                                                                */
			return;
		}

		if (at_idx <= handler_idx) {
			path_idx = at_idx;
		}
	}

	current_target = /*                  */ (path[path_idx] || event.target);
	/*                                                                                                   */
	/*                                                                                                        */
	/*                                                                                                   */
	if (current_target === handler_element) return;

	/*                                    */
	define_property(event, 'currentTarget', {
		configurable: true,
		get() {
			return current_target || owner_document;
		}
	});

	/*                                                                                        */
	/*                                                                                                */
	/*                                                                                                    */
	/*                                                                                               */
	/*                                                                    */
	var previous_reaction = active_reaction;
	var previous_effect = active_effect;
	set_active_reaction(null);
	set_active_effect(null);

	try {
		/**
 *
 */
		var throw_error;
		/**
 *
 */
		var other_errors = [];

		while (current_target !== null) {
			/*                         */
			var parent_element =
				current_target.assignedSlot ||
				current_target.parentNode ||
				/*              */ (current_target).host ||
				null;

			try {
				/*               */
				var delegated = current_target['__' + event_name];

				if (
					delegated != null &&
					(!(/*              */ (current_target).disabled) ||
						/*                                                                                      */
						/*                                                                                       */
						event.target === current_target)
				) {
					if (is_array(delegated)) {
						var [fn, ...data] = delegated;
						fn.apply(current_target, [event, ...data]);
					} else {
						delegated.call(current_target, event);
					}
				}
			} catch (error) {
				if (throw_error) {
					other_errors.push(error);
				} else {
					throw_error = error;
				}
			}
			if (event.cancelBubble || parent_element === handler_element || parent_element === null) {
				break;
			}
			current_target = parent_element;
		}

		if (throw_error) {
			for (let error of other_errors) {
				/*                                                      */
				queueMicrotask(() => {
					throw error;
				});
			}
			throw throw_error;
		}
	} finally {
		/*                             */
		event.__root = handler_element;
		/*                                       */
		delete event.currentTarget;
		set_active_reaction(previous_reaction);
		set_active_effect(previous_effect);
	}
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function apply(
	thunk,
	element,
	args,
	component,
	loc,
	has_side_effects = false,
	remove_parens = false
) {
	let handler;
	let error;

	try {
		handler = thunk();
	} catch (e) {
		error = e;
	}

	if (typeof handler !== 'function' && (has_side_effects || handler != null || error)) {
		const filename = component?.[FILENAME];
		const location = loc ? ` at ${filename}:${loc[0]}:${loc[1]}` : ` in ${filename}`;
		const phase = args[0]?.eventPhase < Event.BUBBLING_PHASE ? 'capture' : '';
		const event_name = args[0]?.type + phase;
		const description = `\`${event_name}\` handler${location}`;
		const suggestion = remove_parens ? 'remove the trailing `()`' : 'add a leading `() =>`';

		w.event_handler_invalid(description, suggestion);

		if (error) {
			throw error;
		}
	}
	handler?.apply(element, args);
}
